<template>
<div class="view about">

    <div class="view__inner">

        <Hero :msg="heroText"
              :padding="false" />

        <StickyImageText :content="stickyImageText" />
        <ProcessTimeline :content="processTimeline" />
        
        <ImageText :content="imageText" />
        <StickyCounter :content="servicesOfferings" />
        
        <Logos :content="experiences" />

    </div>

    <TheSiteFooterNew />

</div>
</template>

<script>
import { mapState } from 'vuex'

// import ScrollSpeed from "./../mixins/scroll-speed";

import Hero from '@/components/Hero.vue'
import ImageText from '@/components/ImageText.vue'
import ProcessTimeline from '@/components/ProcessTimeline.vue'
import StickyCounter from '@/components/StickyCounter.vue'
import StickyImageText from '@/components/StickyImageText.vue'
import TheSiteFooter from '@/components/TheSiteFooter.vue'
import TheSiteFooterNew from '@/components/TheSiteFooterNew.vue'
import Logos from '@/components/Logos.vue'

export default {
    name: 'contact',
    // mixins: [ ScrollSpeed ],
    components: {
        Hero,
        ImageText,
        ProcessTimeline,
        StickyCounter,
        StickyImageText,
        TheSiteFooter,
        TheSiteFooterNew,
        Logos
    },
    computed: mapState({
        heroText: state => state.data.aboutPage.heading,
        imageText: state => state.data.aboutPage.imageText,
        processTimeline: state => state.data.aboutPage.processTimeline,
        servicesOfferings: state => state.data.aboutPage.servicesOfferings,
        stickyImageText: state => state.data.aboutPage.stickyImageText,
        experiences: state => state.data.aboutPage.experiences
    }),
    mounted() {
        this.$nextTick(() => this.$store.commit('SET_LIGHT_THEME', false))
    }
}
</script>

<style lang="scss">
@import "../scss/globals.scss";

.about {
    height: 100vh;
    z-index: 2;
}

.item-list {
    padding-bottom: 500px;
    display: flex;

    &__element {
        border: 2px dashed grey;
        color: red;
        font-size: 3vw;
        width: 16%;
        margin: 0 2%;
        background: rgba(0,0,0,0.2);
        padding-bottom: 13%;
    }
}

</style>
